import { CreatePaymentStatus } from '@/store/slices/stagesSlice/interfaces'
import { useEffect, useState } from 'react'

type Status = CreatePaymentStatus | 'exhausted'

type UseFetchPaymentStatusArgs = {
  fetchData: () => void
  status: Status
  setStatus: (status: Status) => void
  delay: number
  maxCountRequest: number
}

export function useFetchPaymentStatus({ fetchData, status, setStatus, delay, maxCountRequest }: UseFetchPaymentStatusArgs) {
  const [countRequests, setCountRequests] = useState<number>(0)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null
    let mc = countRequests ? delay : 0
    if (status === 'pending' && countRequests < maxCountRequest) {
      timeoutId = setTimeout(() => {
        setCountRequests(pr => pr + 1)
        fetchData()
      }, mc)
    }

    if (countRequests >= maxCountRequest) {
      setStatus('exhausted')
    }

    return () => {
      timeoutId && clearTimeout(timeoutId)
    }
  }, [status, fetchData, countRequests, setCountRequests])
}
